import { AllowedChain } from '@/types';
import { Hex } from 'viem';
import { NETWORK_NAME } from '../constants';

const BEACON_FACTORY_ADDRESS_MAP: Record<AllowedChain, Hex> = {
  [AllowedChain.Sepolia]: '0x29Cefb7074E26Ca5766060fBb56f86DFdBfa40D6',
  [AllowedChain.Gnosis]: '0xFA40B3E1dAad522b9Ad31E0a00cfe808fb8Eb15f',
};

export const BEACON_FACTORY_ADDRESS = BEACON_FACTORY_ADDRESS_MAP[NETWORK_NAME];

export const FORWARDER_ADDRESS = '0x2aA0f271f40ce811fcB2feA1b7186F36b70EF4ad';

export const IDENTITY_STORAGE_URL =
  process.env.NEXT_PUBLIC_IDENTITY_STORAGE_URL;

export const KEY_STORE_UPLOAD_ROUTE = `${IDENTITY_STORAGE_URL}/upload`;
